import { Injectable } from '@angular/core';

export type SavingPlanSuggestionSegment = '1' | '100' | '150' | '300';

@Injectable({
  providedIn: 'root',
})
export class SavingPlanSuggestionsService {
  public getSuggestions(segment: SavingPlanSuggestionSegment): SavingPlanSuggestion[] {
    switch (segment) {
      case '1':
        return SUGGESTION_1;
      case '100':
        return SUGGESTION_100;
      case '150':
        return SUGGESTION_150;
      case '300':
        return SUGGESTION_300;
      default:
        throw new Error(`unknown segment ${segment}`);
    }
  }
}

export interface SavingPlanSuggestion {
  isin: string;
  name: string;
  amount: number;
}

const SUGGESTION_300: SavingPlanSuggestion[] = [
  { isin: 'IE00BKX55R35', name: 'Vanguard FTSE North America', amount: 35 },
  { isin: 'LU0908500753', name: 'Lyxor Core STOXX Europe 600', amount: 30 },
  { isin: 'IE00BKM4GZ66', name: 'iShares Core MSCI EM IMI', amount: 25 },
  { isin: 'IE00B9F5YL18', name: 'Vanguard FTSE Developed Asia Pacific ex Japan', amount: 5 },
  { isin: 'LU1781541252', name: 'Amundi MSCI Japan', amount: 5 },
];

const SUGGESTION_150: SavingPlanSuggestion[] = [
  { isin: 'IE00BJ0KDQ92', name: 'Xtrackers MSCI World', amount: 57 },
  { isin: 'IE00BKM4GZ66', name: 'iShares Core MSCI EM IMI', amount: 26 },
  { isin: 'IE00BF4RFH31', name: 'iShares MSCI World Small Cap', amount: 17 },
];

const SUGGESTION_100: SavingPlanSuggestion[] = [
  { isin: 'IE00BJ0KDQ92', name: 'Xtrackers MSCI World', amount: 70 },
  { isin: 'IE00BKM4GZ66', name: 'iShares Core MSCI EM IMI', amount: 30 },
];

const SUGGESTION_1: SavingPlanSuggestion[] = [{ isin: 'IE00BJ0KDQ92', name: 'Xtrackers MSCI World', amount: 100 }];
